<template>
    <div>
      <loading :active.sync="loader.isLoading" :can-cancel="loader.canCancel" :is-full-page="loader.fullPage" :color="loader.color" :height="loader.height" :width="loader.width" :background-color="loader.backgroundColor" :loader="loader.loader"></loading>
      <div class="row">
        <div class="col-md-12">
          <div class="top-list-small-toolbar">
              <div>
                  <h4 class="text-primary">Laba Rugi</h4>
                  <div class="form-inline">
                      <div class="button-group">
                          <span><b>Company:</b> </span>
                          <select v-model="company_no" class="btn btn-sm btn-soft-outline-primary">
                          <option value="">-- All --</option>
                            <option v-for="c in companyList" :key="c.id" :value="c.company_no">{{ c.name }}</option>
                          </select>
                      </div>
                      <div class="button-group ml-1">
                          <span class="mr-1"><b>Date:</b> </span>
                          <date-picker v-model="startDate" type="date" range placeholder="Select date range"></date-picker>
                      </div>
                      <button type="button" class="btn btn-sm btn-soft-outline-primary ml-1" @click="refreshList">
                        <i class="fa fa-refresh" aria-hidden="true"></i> Refresh
                      </button>
                      <button type="button" class="btn btn-sm btn-hard-primary ml-1" @click="processLabaRugi">
                        Process
                      </button>
                      <button class="btn btn-warning btn-sm pull-left dropdown-toggle" type="button" id="print" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        <i class="fa fa-print" aria-hidden="true"></i> Print
                      </button>
                      <div class="dropdown-menu" aria-labelledby="print">
                        <a class="dropdown-item" href="javascript:void(0)" @click="print('pdf')">PDF</a>
                        <a class="dropdown-item" href="javascript:void(0)" @click="print('excel')">Excel</a>
                      </div>
                  </div>
              </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="card" style="margin-top: 150px;">
            <div class="card-body">
              <button class="btn btn-sm btn-soft-primary mb-3" @click="getProfitLossMonthly" v-if="loadChart === false">Get Chart</button>
              <button class="btn btn-sm btn-soft-primary mb-3" type="button" disabled v-else>
                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
              </button>
              <v-chart class="chart" :option="optionProfit" />
             </div>
          </div>
          <div class="card">
            <div class="card-body">
                <div class="row">
                    <div class="col-md-12">
                      <ul class="nav nav-tabs nav-bordered">
                        <li class="nav-item"><a href="#general" data-toggle="tab" aria-expanded="false" class="nav-link active">Laba Rugi</a></li>
                        <li class="nav-item"><a href="#group" data-toggle="tab" aria-expanded="false" class="nav-link">Group</a></li>
                      </ul>
                      <div class="tab-content">
                        <div class="tab-pane active" id="general">
                          <div class="text-center">
                            <h5>Laba Rugi</h5>
                            <h5>{{ companyData.name }}</h5>
                            <h5>{{ companyData.address }}</h5>
                          </div>
                          <div class="table-responsive">
                            <table class="table table-item mb-0 table-sm table-striped table-hover">
                                <tr>
                                    <th>Account</th>
                                    <th class="text-right">Subtotal</th>
                                    <th class="text-right">Total</th>
                                </tr>
                                <tbody>
                                    <tr v-for="a in accountCompany" :key="a.id">
                                        <!-- column 1 -->
                                        <td v-if="a.hierarcy==4" style="background-color: #1A1A2E; color: white;"><span v-if="a.hierarcy==4" class="ml-5"><b class="font-14">{{ a.name }}</b></span></td>
                                        <td v-else>
                                          <span v-if="a.hierarcy==1"><b>{{ a.code }} {{ a.name }}</b></span>
                                          <span v-else-if="a.hierarcy==2" class="ml-3">{{ a.code }} {{ a.name }}</span>
                                          <span v-else-if="a.hierarcy==3" class="ml-5"><b>{{ a.name }} ({{ a.code }})</b></span>
                                        </td>
                                        <!-- End column 1 -->
                                        <!-- column 2 -->
                                        <td style="background-color: #1A1A2E; color: white;" v-if="a.hierarcy==4"></td>
                                        <td class="text-right" v-else><span v-show="a.hierarcy == 2">{{ a.total }}</span></td>
                                        <!-- End column 2 -->
                                        <!-- column 3 -->
                                        <td class="text-right" v-if="a.hierarcy==4" style="background-color: #1A1A2E; color: white;"><span v-show="a.hierarcy == 4"><b>{{ a.total }}</b></span></td>
                                        <td class="text-right" v-else><span v-show="a.hierarcy == 3"><b>{{ a.total }}</b></span></td>
                                        <!-- End column 3 -->
                                    </tr>
                                </tbody>
                                <tfoot>
                                  <tr>
                                    <td class="text-right">Account Saldo:</td>
                                    <td colspan="2" class="text-right"><b>{{ saldoAccount | currency }}</b></td>
                                  </tr>
                                </tfoot>
                            </table>
                          </div>
                        </div>
                        <div class="tab-pane" id="group">
                          <div class="table-responsive">
                            <table class="table table-item mb-0 table-sm table-striped table-hover">
                              <thead>
                                  <th>Account</th>
                                  <th class="text-right">PPN</th>
                                  <th class="text-right">NON PPN</th>
                                  <th class="text-right">AKUMULASI</th>
                              </thead>
                              <tbody>
                                <tr v-for="g in accountAkumulasi" :key="g.id">
                                  <td>
                                    <span v-if="g.name === 'LABA KOTOR' ||  g.name === 'LABA/RUGI Sebelum Pajak' || g.name === 'Laba Bersih'" class="ml-5"><b>{{ g.name }}</b></span>
                                    <span v-else>{{ g.name }}</span>
                                  </td>
                                  <td class="text-right">
                                    <span v-if="g.name === 'LABA KOTOR' ||  g.name === 'LABA/RUGI Sebelum Pajak' || g.name === 'Laba Bersih'" class="ml-5"><b>{{ g.ppn | currency }}</b></span>
                                    <span v-else>{{ g.ppn | currency }}</span>
                                  </td>
                                  <td class="text-right">
                                    <span v-if="g.name === 'LABA KOTOR' ||  g.name === 'LABA/RUGI Sebelum Pajak' || g.name === 'Laba Bersih'" class="ml-5"><b>{{ g.nonppn | currency }}</b></span>
                                    <span v-else>{{ g.nonppn | currency }}</span>
                                  </td>
                                  <td class="text-right">
                                    <span v-if="g.name === 'LABA KOTOR' ||  g.name === 'LABA/RUGI Sebelum Pajak' || g.name === 'Laba Bersih'" class="ml-5"><b>{{ g.akumulasi | currency }}</b></span>
                                    <span v-else>{{ g.akumulasi | currency }}</span>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <!-- <div class="col-md-4"><pre>{{ optionProfit }}</pre></div> -->
        <!-- <div class="col-md-4"><pre>{{ accountCompany }}</pre></div> -->
        <!-- <div class="col-md-4"><pre>{{ accountAkumulasi }}</pre></div> -->
      </div>
    </div>
</template>
<script>
import Axios from 'axios'
import { accountUrl, financeUrl, getHeader, report2Url, reportUrl } from '../../config'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import { mapState } from 'vuex'
import DatePicker from 'vue2-datepicker'
import { use } from 'echarts/core'
import { CanvasRenderer } from 'echarts/renderers'
import { LineChart } from 'echarts/charts'
import { TitleComponent, TooltipComponent, LegendComponent, GridComponent } from 'echarts/components'
import VChart, { THEME_KEY } from 'vue-echarts'

use([
  CanvasRenderer,
  LineChart,
  TitleComponent,
  TooltipComponent,
  LegendComponent,
  GridComponent
])

export default {
  name: 'LabaRugi',
  components: {
    Loading,
    DatePicker,
    VChart
  },
  provide: { [THEME_KEY]: 'light' },
  computed: {
    ...mapState({
      companyList: state => state.companies.companyList
    }),
    accountCompany () {
      let account = []
      if (this.company_no === 'C0001') {
        account = this.accountPPN
      } else if (this.company_no === 'C0002') {
        account = this.account
      } else {
        account = this.accountAll
      }
      return account
    },
    accountAkumulasi () {
      var loop = []
      var arrPpn = this.accountPPN.filter(d => d.hierarcy === 4)
      var arrNon = this.account.filter(d => d.hierarcy === 4)
      for (let i = 0; i < arrPpn.length; i++) {
        if (arrPpn[i].name !== 'Total Pendapatan') {
          for (let a = 0; a < arrNon.length; a++) {
            if (arrPpn[i].name === arrNon[a].name) {
              const akumulasiTotal = parseFloat(arrPpn[i].total_raw) + parseFloat(arrNon[a].total_raw)
              const name = arrNon[a].name.replace('Total', '')
              const obj = {
                code: arrNon[a].code,
                name: name,
                ppn: arrPpn[i].total_raw,
                nonppn: arrNon[a].total_raw,
                akumulasi: akumulasiTotal
              }
              loop.push(obj)
            }
          }
        }
      }
      return loop
    },
    accountTotal () {
      var array = this.account.filter(d => d.hierarcy === 4)
      return array
    },
    companyData () {
      var obj = {
        name: null,
        address: null
      }
      const cmp = this.companyList.find(d => d.company_no === this.company_no)
      if (cmp) {
        obj = {
          name: cmp.name,
          address: cmp.address
        }
      }
      return obj
    }
  },
  mounted () {
    this.$store.dispatch('getCompanyList')
    if (window.localStorage.getItem('authUser')) {
      const authU = window.localStorage.getItem('authUser')
      const auth = JSON.parse(authU)
      console.log('auth session')
      console.log(auth)
      this.company_no = auth.user.company_no
    }
  },
  data () {
    var date = new Date()
    var firstDay = new Date(date.getFullYear(), date.getMonth(), 1)
    var lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0)
    const date1 = new Date(firstDay.getFullYear(), firstDay.getMonth(), firstDay.getDate())
    const date2 = new Date(lastDay.getFullYear(), lastDay.getMonth(), lastDay.getDate())
    return {
      loadChart: false,
      akumulasiGroup: [{
        code: null,
        name: null,
        ppn: 0,
        nonppn: 0,
        akumulasi: 0
      }],
      option: {},
      option2: {},
      option3: {},
      optionProfit: {
        title: {
          text: 'Profit Loss By Monthly',
          left: 'left'
        },
        legend: {},
        tooltip: {
          trigger: 'axis'
        },
        xAxis: {
          type: 'category',
          data: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
        },
        yAxis: {
          type: 'value'
        },
        series: [{
          data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
          type: 'line',
          name: 'Profit/Loss',
          itemStyle: { color: '#22C3AA' },
          showBackground: true,
          backgroundStyle: {
            color: 'rgba(180, 180, 180, 0.2)'
          }
        }]
      },
      saldoAccount: 0,
      profitNet: 0,
      profitNetPPN: 0,
      loader: {
        isLoading: false,
        fullPage: true,
        color: '#007bff',
        canCancel: true,
        height: 128,
        width: 128,
        backgroundColor: '#ffffff',
        loader: 'spinner'
      },
      company_no: null,
      startDate: [date1, date2],
      begin: new Date(),
      end: new Date(),
      contact: null,
      month: date.getMonth() + 1,
      year: date.getFullYear(),
      saldoAwal: 0,
      saldoAkhir: null,
      totalLabaRugi: null,
      account: [{
        id: null,
        hierarcy: null,
        parent_code: null,
        code: null,
        name: null,
        notes: null,
        account_balance: null,
        method: null,
        group_id: null,
        total: null
      }],
      accountPPN: [{
        id: null,
        hierarcy: null,
        parent_code: null,
        code: null,
        name: null,
        notes: null,
        account_balance: null,
        method: null,
        group_id: null,
        total: null
      }],
      accountAll: [{
        id: null,
        hierarcy: null,
        parent_code: null,
        code: null,
        name: null,
        notes: null,
        account_balance: null,
        method: null,
        group_id: null,
        total: null
      }],
      money: {
        decimal: ',',
        thousands: '.',
        prefix: '',
        suffix: '',
        precision: 0,
        masked: true /* doesn't work with directive */
      }
    }
  },
  methods: {
    async getProfitLossMonthly () {
      this.loadChart = true
      const year = this.startDate[0].getFullYear()
      let account = []
      if (this.company_no === null || this.company_no === '') {
        account = ['11-320-002', '01-320-002']
      } else if (this.company_no === 'C0001') {
        account = ['01-320-002']
      } else if (this.company_no === 'C0002') {
        account = ['11-320-002']
      }
      var obj = {
        year: year,
        account_code: account
      }
      console.log(obj)
      await Axios.post(reportUrl + '/profit-lost-monthly', obj, { headers: getHeader() })
        .then(response => {
          var data = []
          var array = response.data.data
          for (let i = 0; i < array.length; i++) {
            data.push(array[i].total)
          }
          console.log(response.data.label)
          console.log(data)
          this.optionProfit = {
            title: {
              text: 'Profit Loss By Monthly',
              left: 'left'
            },
            legend: {},
            tooltip: {
              trigger: 'axis'
            },
            xAxis: {
              type: 'category',
              data: response.data.label
            },
            yAxis: {
              type: 'value'
            },
            series: [{
              data: data,
              type: 'line',
              name: 'Profit/Loss',
              itemStyle: { color: '#22C3AA' },
              showBackground: true,
              backgroundStyle: {
                color: 'rgba(180, 180, 180, 0.2)'
              }
            }]
          }
          this.loadChart = false
        })
        .catch(error => {
          this.loadChart = false
          console.log(error)
          console.log(error.response)
          this.$swal('Error', error.response.data.message, 'error')
          throw error
        })
    },
    async getAccountSaldo () {
      var account = []
      if (this.company_no === null || this.company_no === '') {
        account = ['11-320-002', '01-320-002']
      } else if (this.company_no === 'C0001') {
        account = ['01-320-002']
      } else if (this.company_no === 'C0002') {
        account = ['11-320-002']
      }
      console.log('getAccountSaldo company: ' + this.company_no)
      console.log(account)
      const begin = this.startDate[0] ? this.startDate[0].getFullYear() + '-' + (this.startDate[0].getMonth() + 1) + '-' + this.startDate[0].getDate() : null
      const end = this.startDate[1] ? this.startDate[1].getFullYear() + '-' + (this.startDate[1].getMonth() + 1) + '-' + this.startDate[1].getDate() : null
      var obj = {
        account: account,
        begin: begin,
        end: end
      }
      console.log(obj)
      console.log(accountUrl + '/get-saldo-account')
      await Axios.post(accountUrl + '/get-saldo-account', obj, { headers: getHeader() })
        .then(response => {
          console.log(response.data.message)
          this.$Progress.finish()
          this.loader.isLoading = false
          this.saldoAccount = response.data.saldo
        })
        .catch(error => {
          console.log(error)
          console.log(error.response)
          this.$Progress.finish()
          this.loader.isLoading = false
          this.$swal('Error', error.response.data.message, 'errro')
          throw error
        })
    },
    async processLabaRugi () {
      this.$Progress.start()
      this.loader.isLoading = true
      var accCode = null
      // Validate company
      if (this.company_no === null || this.company_no === '') {
        this.$swal('Error', 'Company cannot be null in process neraca', 'error')
        this.$Progress.finish()
        this.loader.isLoading = false
        return false
      }
      if (this.company_no === 'C0001') {
        accCode = '01-320-002'
      } else if (this.company_no === 'C0002') {
        accCode = '11-320-002'
      }
      const begin = this.startDate[0] ? this.startDate[1].getFullYear() + '-' + (this.startDate[0].getMonth() + 1) + '-' + this.startDate[0].getDate() : null
      const end = this.startDate[1] ? this.startDate[1].getFullYear() + '-' + (this.startDate[1].getMonth() + 1) + '-' + this.startDate[1].getDate() : null
      for (var d = new Date(begin); d <= new Date(end); d.setDate(d.getDate() + 1)) {
        const date = new Date(d)
        const processDate = date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate()
        var url = financeUrl + '/laba-rugi?begin=' + processDate + '&end=' + processDate + '&company=' + this.company_no
        var profitNet = 0
        await Axios.get(url, { headers: getHeader() })
          .then(response => {
            profitNet = response.data.profit_net
          })
          .catch(error => {
            console.log(error)
            console.log(error.response)
          })
        var obj = {
          account_code: accCode,
          saldo: profitNet,
          saldo_date: processDate,
          method: 'debet',
          term: 'overwrite'
        }
        await Axios.post(accountUrl + '/saldo', obj, { headers: getHeader() })
          .then(response => {
            console.log(response.data.message)
          })
          .catch(error => {
            console.log(error)
            console.log(error.response)
            throw error
          })
      }
      await this.$Progress.finish()
      this.loader.isLoading = false
    },
    editJournal: function (id) {
      alert(id)
    },
    async multiRefresh () {
    },
    async refreshList () {
      this.$Progress.start()
      this.loader.isLoading = true
      await this.getProfitLossMonthly()
      const begin = this.startDate[0] ? this.startDate[0].getFullYear() + '-' + (this.startDate[0].getMonth() + 1) + '-' + this.startDate[0].getDate() : null
      const end = this.startDate[1] ? this.startDate[1].getFullYear() + '-' + (this.startDate[1].getMonth() + 1) + '-' + this.startDate[1].getDate() : null
      var url = financeUrl + '/laba-rugi?begin=' + begin + '&end=' + end + '&company=C0002'
      await Axios.get(url, { headers: getHeader() })
        .then(response => {
          this.account = response.data.data
          this.profitNet = response.data.profit_net
          this.totalLabaRugi = response.data.totalLabaRugi
          this.$Progress.finish()
          this.loader.isLoading = false
        })
        .catch(error => {
          console.log(error)
          console.log(error.response)
          this.$swal('Error', error.response.data.message, 'error')
          throw error
        })
      var url2 = financeUrl + '/laba-rugi?begin=' + begin + '&end=' + end + '&company=C0001'
      await Axios.get(url2, { headers: getHeader() })
        .then(response => {
          this.accountPPN = response.data.data
          this.profitNetPPN = response.data.profit_net
        })
        .catch(error => {
          console.log(error)
          console.log(error.response)
          this.$swal('Error', error.response.data.message, 'error')
          throw error
        })
      var urlakumulasi = financeUrl + '/laba-rugi?begin=' + begin + '&end=' + end + '&company='
      await Axios.get(urlakumulasi, { headers: getHeader() })
        .then(response => {
          this.accountAll = response.data.data
        })
        .catch(error => {
          console.log(error)
          console.log(error.response)
          this.$swal('Error', error.response.data.message, 'error')
          throw error
        })
      await this.getAccountSaldo()
    },
    async print (format) {
      this.$Progress.start()
      this.loader.isLoading = true
      const begin = this.startDate[0] ? this.startDate[0].getDate() + '/' + (this.startDate[0].getMonth() + 1) + '/' + this.startDate[0].getFullYear() : null
      const end = this.startDate[1] ? this.startDate[1].getDate() + '/' + (this.startDate[1].getMonth() + 1) + '/' + this.startDate[1].getFullYear() : null
      var data = {
        format: format,
        company: this.companyData,
        period: [begin, end],
        account: this.accountCompany
      }
      console.log(data)
      if (data.length === 0) {
        this.$swal('Error', 'Data masih kosong', 'error')
        return false
      }
      await Axios.post(report2Url + '/laba-rugi', data, { responseType: 'blob' })
        .then(response => {
          const objectUrl = URL.createObjectURL(response.data)
          console.log('Showing PDF...')
          window.open(objectUrl, '_blank')
          this.$Progress.finish()
          this.loader.isLoading = false
        })
        .catch(error => {
          this.$Progress.finish()
          this.loader.isLoading = false
          console.log(error)
          console.log(error.response)
        })
    }
  }
}
</script>

<style scoped>
  .first-col {
    position: absolute;
    width: 5em;
    margin-left: -5em;
  }
  .chart {
    height: 360px;
  }
</style>
